import React, {Component} from 'react';
import {client} from '../../Client';
import { Button, Form, Input, Message, Checkbox, Radio, Divider } from 'semantic-ui-react'
import {convertNullToEmptyString, arrayToCombo, capitalizeFirstLetter, arrayToComboAdd} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import {Redirect} from 'react-router-dom';
import {PropTypes} from 'prop-types';

const optionsSoggettiSesso = [
    { key: 'm', text: 'Maschio', value: 'm' },
    { key: 'f', text: 'Femmina', value: 'f' },
    { key: '?', text: 'Non dichiarato', value: '?' },
]

class RubricaFormAll extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id, // Se undefined siamo in insert, altrimenti in update
            inUpdate: this.props.match.params.id !== undefined,
            cfg: client.getConfigurazione(),
            fields: this.getEmptyFields(),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            cancelSuccess: false,
            error: null,
            soggettoTitoliList: [],
            organizzazioniList: [],
            organizzazione: null,
            dipartimento:null,
            dipartimentiList: [],
            statoOrganizzazione: 'S', // S, N (New), E (Edit)
            statoDipartimento: 'S', // S, N (New), E (Edit)
            dropdownOrganizzazioniLoading: false,
            dropdownDipartimentiLoading: false,
            dropdownTitoliLoading: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.setDipartimentoFromCfg = this.setDipartimentoFromCfg.bind(this)
        this.setPrvcyMisureAdottateFromCfg = this.setPrvcyMisureAdottateFromCfg.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onInputCheckboxChange = this.onInputCheckboxChange.bind(this)
        this.onInputRadioChange = this.onInputRadioChange.bind(this)
        this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
        this.onInputChangeFirstCharUppercase = this.onInputChangeFirstCharUppercase.bind(this)
        this.onDropdownAddOrganizzazione = this.onDropdownAddOrganizzazione.bind(this)
        this.onDropdownAddDipartimento = this.onDropdownAddDipartimento.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.loadOrganizzazione = this.loadOrganizzazione.bind(this)
        this.loadDipartimento = this.loadDipartimento.bind(this)
        this.isNessunaOrganizzazione = this.isNessunaOrganizzazione.bind(this)
        this.isNessunDipartimento= this.isNessunDipartimento.bind(this)
        this.isIndirizzoSoggetto = this.isIndirizzoSoggetto.bind(this)
        this.isIndirizzoOrganizzazione = this.isIndirizzoOrganizzazione.bind(this)
        this.isIndirizzoDipartimento = this.isIndirizzoDipartimento.bind(this)
        this.isIndirizzoDipartimento = this.isIndirizzoDipartimento.bind(this)
        this.onDropdownAddOrganizzazione = this.onDropdownAddOrganizzazione.bind(this)
        this.onDropdownAddDipartimento = this.onDropdownAddDipartimento.bind(this)
    }

    isLoadingInProgress(){
        return this.state._loading || this.state.dropdownOrganizzazioniLoading || this.state.dropdownDipartimentiLoading || this.state.dropdownTitoliLoading;
    }

    setDipartimentoFromCfg(cfg){
        if (!this.state.inUpdate && this.state.dipartimento === null){
            let organizzazione = cfg.idDipartimento.idOrganizzazione;
            let dipartimento = cfg.idDipartimento;
            this.comboDipartimenti(organizzazione.idOrganizzazione)
            const fields = this.state.fields;
            fields["idDipartimento"] = dipartimento.idDipartimento;
            fields["idOrganizzazione"] = organizzazione.idOrganizzazione;
            fields["organizzazione"] = organizzazione;
            fields["dipartimento"] = dipartimento;
            this.setState({
                dipartimento: dipartimento,
                organizzazione: organizzazione,
                statoOrganizzazione: 'S',
                statoDipartimento: 'S',
                fields,
            });

        }
    }

    setPrvcyMisureAdottateFromCfg(cfg){
        if (!this.state.inUpdate && this.state.soggetto.prvcyMisureAdottate === null){
            const fields = this.state.fields;
            console.log("fields:", fields);
            console.log("cfg:", cfg.prvcyMisureAdottate);
            fields["soggetto"]["prvcyMisureAdottate"] = cfg.prvcyMisureAdottate;
            this.setState({
                fields,
            });

        }
    }

    comboOrganizzazioni(organizzazione = undefined){
        this.setState({ dropdownOrganizzazioniLoading: true });
        client.loadOrganizzazioniList(
            10000, 1,[{field:'o.nome', direction:'A'}]
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    let orgList = arrayToCombo(data.items, "idOrganizzazione", "nomeCompleto", "idOrganizzazione", false);
                    if (organizzazione !== undefined){
                        orgList = arrayToComboAdd(orgList, organizzazione,"idOrganizzazione", "nomeCompleto", "idOrganizzazione");
                    }
                    this.setState({
                        dropdownOrganizzazioniLoading: false,
                        error: null,
                        organizzazioniList: orgList
                    })
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownOrganizzazioniLoading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownOrganizzazioniLoading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }
    onDropdownAddOrganizzazione (e, { value })  {
        let organizzazione = this.getEmptyFieldsOrganizzazione();
        organizzazione = Object.assign(organizzazione,  {idOrganizzazione: -1, nomeCompleto: value, nome: value});

        let dipartimento = this.getEmptyFieldsDipartimento();
        dipartimento = Object.assign(dipartimento, {idDipartimento: -1, nomeCompleto: '', nome: ''});
        let orgList = arrayToComboAdd(this.state.organizzazioniList, organizzazione,"idOrganizzazione", "nomeCompleto", "idOrganizzazione");
        let dipList = arrayToComboAdd([], dipartimento,"idDipartimento", "nomeCompleto", "idDipartimento");

        const fields = this.state.fields;
        fields.idOrganizzazione = -1;
        fields.idDipartimento = -1;
        fields.organizzazione = organizzazione;
        fields.dipartimento = dipartimento;

        this.setState({
            organizzazione: organizzazione,
            organizzazioniList: orgList,
            dipartimento: dipartimento,
            dipartimentiList: dipList,
            fields
        });
    }

    comboDipartimenti(idOrganizzazione, cb, dipartimento = undefined){
        this.setState({ dropdownDipartimentiLoading: true });
        client.loadDipartimentiByOrganizzazione(idOrganizzazione).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    let dipList = arrayToCombo(data.items, "idDipartimento", "nomeCompleto", "idDipartimento", false)
                    if (dipartimento !== undefined){
                        dipList = arrayToComboAdd(dipList, dipartimento,"idDipartimento", "nomeCompleto", "idDipartimento");
                    }
                    this.setState({
                        dropdownDipartimentiLoading: false,
                        error: null,
                        dipartimentiList: dipList,
                    });
                    if (cb !== undefined){
                        // Chiama la callback per ulteriori elaborazioni
                        cb(data.items);
                    }

                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownDipartimentiLoading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownDipartimentiLoading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });

    }
    onDropdownAddDipartimento(e, { value }) {

        let dipartimento = this.getEmptyFieldsDipartimento();
        dipartimento =  Object.assign(dipartimento, {idDipartimento: -1, nomeCompleto: value, nome: value});
        let dipList = arrayToComboAdd(this.state.dipartimentiList, dipartimento,"idDipartimento", "nomeCompleto", "idDipartimento");

        const fields = this.state.fields;
        fields.idDipartimento = -1;
        fields["dipartimento"] = dipartimento;

        this.setState({
            dipartimento: dipartimento,
            dipartimentiList: dipList,
            fields
        });
    }

    comboTitoli(){
        this.setState({ dropdownTitoliLoading: true });
        client.loadSoggettiTitoliList().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        dropdownTitoliLoading: false,
                        error: null,
                        soggettoTitoliList: arrayToCombo(data.items, "titolo", "descrizione", "titolo")

                    })
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownTitoliLoading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownTitoliLoading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    componentWillMount() {
        // Carica gli elenchi base
        this.comboTitoli();
        this.comboOrganizzazioni();
    }

    componentDidMount() {

        if (this.state.inUpdate)
        {
            this.setState({ _loading: true });
            client.loadRubrica(this.state.id).then(
                (response) => {
                    if (response.ok){
                        response.json().then((data) => {

                            //data = convertNullToEmptyString(data, ['isCliente', 'isFornitore', 'isTp']);
                            data = convertNullToEmptyString(data);
                            data.soggetto["idOrganizzazione"] = data.organizzazione.idOrganizzazione;
                            this.setState({
                                _loading: false,
                                fields: {
                                    soggetto: data.soggetto,
                                    organizzazione: data.organizzazione,
                                    dipartimento: data.dipartimento,
                                    idOrganizzazione: data.organizzazione.idOrganizzazione,
                                    idDipartimento: data.dipartimento.idDipartimento
                                },
                                fieldErrors: {},
                                fieldErrorsText: [], inError: false, error: null,
                                organizzazione: data.organizzazione,
                                dipartimento: data.dipartimento,
                            });
                            this.comboDipartimenti(data.organizzazione.idOrganizzazione)
                            this.forceUpdate();
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.context.router.transitionTo("/login")
                    }
                    else
                    {
                        response.json().then((errore) => {
                            let fieldErrorsText = []
                            let fieldErrors = {}
                            this.setState({
                                _loading: false,
                                fieldErrors: fieldErrors,
                                fieldErrorsText: fieldErrorsText,
                                errorTitle: '',
                                error: {title: errore.title, msg: errore.msg},
                                inError: true
                            });
                        });

                    }
            }).catch((error) => {

                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });

            });
        }
        else
        {
            this.setDipartimentoFromCfg(client.getConfigurazione());
            this.setPrvcyMisureAdottateFromCfg(client.getConfigurazione());

        }
    }

    getEmptyFields() {
        return {
            soggetto: this.getEmptyFieldsSoggetto(),
            organizzazione: this.getEmptyFieldsOrganizzazione(),
            dipartimento: this.getEmptyFieldsDipartimento()
        }
    }

    getEmptyFieldsSoggetto() {

        console.log("CFG:", client.getConfigurazione());
        return {
            'nome': '',
            'cognome': '',
            'titolo': '',
            'sesso': '',
            'indirizzo' : '',
            'cap' : '',
            'citta' : '',
            'provincia' : '',
            'stato' : '',
            'piva' : '',
            'cfisc' : '',
            'email' : '',
            'pec' : '',
            'web' : '',
            'cellulare' : '',
            'perCellulare' : '',
            'perEmail' : '',
            'telefono1' : '',
            'telefono2' : '',
            'fax' : '',
            'nomeOrg' : '',
            'telOrg' : '',
            'cellDip' : '',
            'emailDip' : '',
            'note' : '',
            'isCliente': false,
            'isFornitore': false,
            'isTp': false,
            'isProspect': false,
            'prvcyConsenso': true,
            'prvcyAvvisato': true,
            'prvcyCatdatPersonali': true,
            'prvcyCatdatIdentificativi': false,
            'prvcyCatdatSensibili': false,
            'prvcyCatdatGiudiziari': false,
            'prvcyDatiSensibili': false,
            'prvcyTermineCancellazione': "0",
            'prvcyCatdstNecessari': true,
            'prvcyCatdstCollaboratori': false,
            'prvcyCatdstPubblicheAmm': false,
            'prvcyCatdstClienti': false,
            'prvcyCatdstFornitori': false,
            'prvcyDestPaesiTerzi': false,
            'prvcyMisureAdottate': client.getConfigurazione().prvcyMisureAdottate,
            'sfilati': false
        }
    }

    getEmptyFieldsOrganizzazione() {
        return {
            'nome': '',
            'indirizzo' : '',
            'cap' : '',
            'citta' : '',
            'provincia' : '',
            'stato' : '',
            'piva' : '',
            'cfisc' : '',
            'email' : '',
            'pec' : '',
            'web' : '',
            'telefono1' : '',
            'telefono2' : '',
            'fax' : '',
            'note' : '',
        }
    }

    getEmptyFieldsDipartimento() {
        return {
            'nome': '',
            'indirizzo' : '',
            'cap' : '',
            'citta' : '',
            'provincia' : '',
            'stato' : '',
            'email' : '',
            'pec' : '',
            'web' : '',
            'telefono1' : '',
            'telefono2' : '',
            'fax' : '',
            'note' : '',
        };
    }

    formIsValid(formData) {

        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (formData.idOrganizzazione === ""){
            fieldErrors["idOrganizzazione"] = true;
            fieldErrorsText.push("Occorre specificare l'Organizzazione di appartenenza del soggetto");
        }
        if (formData.idDipartimento === ""){
            fieldErrors["idDipartimento"] = true;
            fieldErrorsText.push("Occorre specificare il Dipartimento di appartenenza del soggetto");
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    handleCancel(e) {
        e.preventDefault();
        this.setState({cancelSuccess: true})
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;

        // Validazione form
        if (!this.formIsValid(formData)){
            return;
        }

        // Salvataggio sul server
        // Normalizza prima la struttura da inviare
        delete formData["idDipartimento-search"];
        delete formData["idOrganizzazione-search"];
        delete formData["stato-search"];
        delete formData["idDipartimento"];
        delete formData["idOrganizzazione"];
        // let record={
        //     soggetto: formData,
        //     dipartimento: this.state.dipartimento,
        //     organizzazione: this.state.organizzazione,
        // }

        let record = formData;
        if (record.dipartimento.idDipartimento === -1){
            delete record.dipartimento.idDipartimento;
        }
        if (record.organizzazione.idOrganizzazione === -1){
            delete record.organizzazione.idOrganizzazione;
        }

        this.setState({_loading: true});
        client.saveRubrica(
            record,
            this.state.fields.soggetto.idSoggetto
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {

                    data = convertNullToEmptyString(data);
                    data.soggetto["idOrganizzazione"] = data.organizzazione.idOrganizzazione;

                    let fields = this.state.fields;
                    fields["idSoggetto"] = data.idSoggetto;
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        successTitle: "Salvataggio soggetto",
                        successText: "Il soggetto è stato salvato correttamente",
                        fields: {soggetto: data.soggetto, organizzazione: data.organizzazione, dipartimento: data.dipartimento},
                        organizzazione: data.organizzazione,
                        dipartimento: data.dipartimento,
                    });
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onInputCheckboxChange(a1, {name, checked}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            this.setState({ fields: this.setFieldValue(fields, name, checked) });
        }
    }

    onInputRadioChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            this.setState({ fields: this.setFieldValue(fields, name, value) });
        }
    }

    onInputChange(a1, {name, value}){

        if (name === "idOrganizzazione" && Number.isInteger(value))
        {
            this.loadOrganizzazione(value, (organizzazione) => {
                const fields = this.state.fields;
                fields[name] = value;
                fields["organizzazione"] = organizzazione;
                this.setState({
                    organizzazione: organizzazione, fields: fields
                });


                if (organizzazione.idOrganizzazione > 0){
                    // Organizzazione scelta, carica i dipartimenti collegati
                    this.comboDipartimenti(organizzazione.idOrganizzazione, (items) => {

                        let dip = this.state.dipartimento;
                        const fields = this.state.fields;

                        // Il dipartimento precedente se c'è è nella lista?
                        if (dip !== undefined && dip !== null)
                        {
                            dip = items.find((it) => {
                                return it.idDipartimento === dip.idDipartimento;
                            })
                        }

                        if ( (dip === null || dip === undefined) )
                        {
                            if (items.length > 0){
                                dip = items[0];
                                fields["idDipartimento"] = dip.idDipartimento;
                                fields["dipartimento"] = dip;
                                this.setState({
                                    dropdownDipartimentiLoading: false,
                                    error: null,
                                    dipartimentiList: arrayToCombo(items, "idDipartimento", "nomeCompleto", "idDipartimento"),
                                    dipartimento: dip,
                                    fields: fields
                                })
                            }
                            else {
                                // Creo un dipartimento di default vuoto che eventualmente verrà completato successivamente
                                this.creaDipartimentoDefault(organizzazione.idOrganizzazione, (dip) => {
                                    fields["idDipartimento"] = dip.idDipartimento;
                                    fields["dipartimento"] = dip;
                                    this.setState({
                                        dropdownDipartimentiLoading: false,
                                        error: null,
                                        dipartimentiList: arrayToCombo([dip], "idDipartimento", "nomeCompleto", "idDipartimento"),
                                        dipartimento: dip,
                                        fields: fields
                                    })
                                });
                            }
                        }
                    })

                }

            });

        }
        else if (name === "idDipartimento"  && Number.isInteger(value))
        {
            this.loadDipartimento(value, (dipartimento) => {
                const fields = this.state.fields;
                fields[name] = value;
                fields["dipartimento"] = dipartimento;

                this.setState({dipartimento: dipartimento, fields: fields});
            })
        }
        else if (name !== undefined)
        {
            const fields = this.state.fields;
            this.setState({ fields: this.setFieldValue(fields, name, value) });
        }

    }

    setFieldValue(fields, name, value){
        console.log("setFieldValue", name, value);
        let fl = name.split('.');
        if (fl.length > 1){
            fields[fl[0]][fl[1]] = value;
        }
        else {
            fields[name] = value;
        }
        return fields;
    }

    loadOrganizzazione(id, cb){
        this.setState({dropdownOrganizzazioniLoading:true})
        client.loadOrganizzazione(id).then(
            (response) => {
                if (response.ok){
                    response.json().then((item) => {
                        this.setState({dropdownOrganizzazioniLoading:false})
                        let obj = convertNullToEmptyString(item);
                        cb(obj)
                    })
                }
                else if (response.status === 401)
                {
                    this.context.router.transitionTo("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            dropdownOrganizzazioniLoading: false,
                        });
                    });

                }
            }).catch((error) => {
            this.setState({
                dropdownOrganizzazioniLoading: false,
            });
        });
    }

    loadDipartimento(id, cb){
        this.setState({dropdownDipartimentiLoading:true})
        client.loadDipartimento(id).then(
            (response) => {
                if (response.ok){
                    response.json().then((item) => {
                        this.setState({dropdownDipartimentiLoading:false})
                        let obj = convertNullToEmptyString(item);
                        cb(obj)
                    })
                }
                else if (response.status === 401)
                {
                    this.context.router.transitionTo("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            dropdownDipartimentiLoading: false,
                        });
                    });

                }
            }).catch((error) => {
            this.setState({
                dropdownDipartimentiLoading: false,
            });
        });
    }


    onInputChangeUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            this.setState({ fields: this.setFieldValue(fields, name, value.toUpperCase()) });
        }
    }

    onInputChangeFirstCharUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            this.setState({ fields: this.setFieldValue(fields, name, capitalizeFirstLetter(value)) });
        }
    }

    creaDipartimentoDefault(idOrganizzazione, cb){
        this.setState({_loading: true})
        client.saveDipartimento(
            {
                idOrganizzazione: idOrganizzazione,
            }
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({_loading: false})
                    cb( data );
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((error) => {
                    this.setState({_loading: false})
                })
            }
        }).catch((error) => {
            this.setState({_loading: false})
        });
    }

    renderSoggettoForm() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let loaderOrganizzazione = '';
        if  (this.state.dropdownOrganizzazioniLoading) {
            loaderOrganizzazione = (
                <div className="ui active inverted dimmer">
                    <div className="ui huge loader"></div>
                </div>
            );
        }
        let loaderDipartimento = '';
        if  (this.state.dropdownDipartimentiLoading) {
            loaderDipartimento = (
                <div className="ui active inverted dimmer">
                    <div className="ui huge loader"></div>
                </div>
            );
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess){
            return <Redirect to={ {
                pathname: '/app/rubrica/list',
                state: {
                    from: this.props.location,
                    item: {
                        soggetto: this.state.fields.soggetto,
                        dipartimento: this.state.dipartimento,
                        organizzazione: this.state.organizzazione,
                    }
                },
            }}/>
        }
        if (this.state.cancelSuccess){
            return <Redirect to={ {
                pathname: '/app/rubrica/list',
                state: {
                    from: this.props.location,
                    item: undefined
                },
            }}/>
        }
        let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Soggetto</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuovo Soggetto</h3>
        let btnSalva = null;
        if (client.getCurrentUser().isrolerubricaw === true){
            btnSalva = (
                <div className="left aligned eight wide column">
                <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
            </div>);
        }
        else {
            btnSalva = (
                <div className="left aligned eight wide column">
                    <Button secondary disabled type='submit' ><i className="save icon"/> Non hai i diritti per salvare</Button>
                </div>                
            );
        }
        
        return (
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                {/*<div>*/}
                    {/*<p><b>Organizzazione nuova?</b>: {this.state.organizzazione ? this.state.organizzazione.idOrganizzazione > 0 ? "NO" : "SI" : "Nessuna scelta"}</p>*/}
                    {/*<p><b>Dipartimento nuovo?</b>: {this.state.dipartimento ? this.state.dipartimento.idDipartimento > 0 ? "NO" : "SI" : "Nessuna scelta"}</p>*/}
                {/*</div>*/}
                {titleMsg}
                <h3 className="ui block attached header">Organizzazione

                <br/>
                    <Form.Group widths="1">
                        <Form.Dropdown
                            width={16}
                            loading={this.state.dropdownOrganizzazioniLoading}
                            label=''
                            name='idOrganizzazione' fluid search selection
                            options={this.state.organizzazioniList}
                            value={this.state.fields.idOrganizzazione}
                            onChange={this.onInputChange}
                            error={this.state.fieldErrors["idOrganizzazione"]}
                            selectOnBlur={false}
                            allowAdditions
                            additionLabel={<span className="ui left floated"><i className="ui add square icon"/>Aggiungi la nuova organizzazione: </span>}
                            onAddItem={this.onDropdownAddOrganizzazione}
                        />
                        {/*<Form.Field width={1} disabled={this.isLoadingInProgress()}>*/}
                        {/*<label>Nuova</label>*/}
                        {/*<a onClick={() => (this.onOrganizzazioneStateChange('N'))} className="ui icon button   "><i className="add icon"/></a>*/}
                        {/*</Form.Field>*/}
                        {/*<Form.Field width={1} disabled={this.state.organizzazione === null || this.state.organizzazione.idOrganizzazione === client.getConfigurazione().idDipartimento.idOrganizzazione.idOrganizzazione || this.isLoadingInProgress()}>*/}
                        {/*<label>Modifica</label>*/}
                        {/*<a onClick={() => (this.onOrganizzazioneStateChange('E'))} className="ui icon button  "><i className="edit icon"/></a>*/}
                        {/*</Form.Field>*/}
                    </Form.Group>
                </h3>
                <div className="ui attached segment">
                    <div hidden={!this.isNessunaOrganizzazione()}>
                    {/* Campi dell' Organizzazione */}
                    <Form.Group widths="4">
                        <Form.Field label="Nome"  required={this.isNessunaOrganizzazione()} control={Input} name='organizzazione.nome'  autoComplete="nope" placeholder='Nome organizzazione' maxLength="100"  value={this.state.fields.organizzazione.nome}  onChange={this.onInputChange}/>
                        <Form.Input label='Sito web' name='organizzazione.web'  autoComplete="nope"  value={this.state.fields.organizzazione.web} error={this.state.fieldErrors["organizzazione.web"]} onChange={this.onInputChange}/>
                        <Form.Input label='P.IVA' disabled={this.state.fields.soggetto.piva} name='organizzazione.piva'  autoComplete="nope" placeholder='' maxLength={11}  value={this.state.fields.organizzazione.piva} onChange={this.onInputChangeUppercase}/>
                        <Form.Input label='Codice Fiscale' disabled={this.state.fields.soggetto.cfisc} name='organizzazione.cfisc'  autoComplete="nope" placeholder='' maxLength={16}  value={this.state.fields.organizzazione.cfisc} onChange={this.onInputChangeUppercase}/>
                    </Form.Group>
                    <Form.Group widths='5'>
                        <Form.Input label='Indirizzo' name='organizzazione.indirizzo'  disabled={this.isIndirizzoSoggetto()} autoComplete="nope" placeholder='Via/Piazza...' width={6} maxLength={255} value={this.state.fields.organizzazione.indirizzo} onChange={this.onInputChange}/>
                        <Form.Input label='Stato' name='organizzazione.stato'  disabled={this.isIndirizzoSoggetto()} placeholder='' autoComplete="nope"  width={1} maxLength={2} value={this.state.fields.organizzazione.stato} onChange={this.onInputChangeUppercase} />
                        <Form.Input label='CAP' name='organizzazione.cap'   disabled={this.isIndirizzoSoggetto()} autoComplete="nope" placeholder='' width={2} maxLength={10} value={this.state.fields.organizzazione.cap} onChange={this.onInputChange} />
                        <Form.Input label='Città' name='organizzazione.citta'   disabled={this.isIndirizzoSoggetto()} autoComplete="nope" placeholder='' width={5} maxLength={255} value={this.state.fields.organizzazione.citta} onChange={this.onInputChangeUppercase}/>
                        <Form.Input label='Provincia' name='organizzazione.provincia'   disabled={this.isIndirizzoSoggetto()} autoComplete="nope" placeholder='' width={2} maxLength={2} value={this.state.fields.organizzazione.provincia} onChange={this.onInputChangeUppercase}/>
                    </Form.Group>
                    <Form.Group widths='5'>
                        <Form.Input label='Email' name='organizzazione.email'  autoComplete="nope"  value={this.state.fields.organizzazione.email} error={this.state.fieldErrors["organizzazione.email"]} onChange={this.onInputChange}/>
                        <Form.Input label='PEC'  name='organizzazione.pec' autoComplete="nope"  value={this.state.fields.organizzazione.pec} error={this.state.fieldErrors["organizzazione.pec"]} onChange={this.onInputChange}/>
                        <Form.Input label='Tel1'  name='organizzazione.telefono1'  maxLength={30} autoComplete="nope" value={this.state.fields.organizzazione.telefono1} error={this.state.fieldErrors["organizzazione.telefono1"]} onChange={this.onInputChange}/>
                        <Form.Input label='Tel2'  name='organizzazione.telefono2' maxLength={30}  autoComplete="nope" value={this.state.fields.organizzazione.telefono2} error={this.state.fieldErrors["organizzazione.telefono2"]} onChange={this.onInputChange}/>
                        <Form.Input label='Fax'  name='organizzazione.fax'  maxLength={30} autoComplete="nope" value={this.state.fields.organizzazione.fax} error={this.state.fieldErrors["organizzazione.fax"]} onChange={this.onInputChange}/>
                    </Form.Group>
                    <Form.TextArea name='organizzazione.note'  autoComplete="nope" label='Note' placeholder='' rows='3' value={this.state.fields.organizzazione.note} onChange={this.onInputChange}/>
                        {loaderOrganizzazione}
                    </div>
                </div>
                <h3 className="ui block attached header">Dipartimento<br/>
                    <Form.Group widths="1">
                        <Form.Dropdown width={16}
                                       loading={this.state.dropdownDipartimentiLoading}
                                       label=''
                                       name='idDipartimento' fluid search selection
                                       options={this.state.dipartimentiList}
                                       value={this.state.fields.idDipartimento}
                                       onChange={this.onInputChange}
                                       selectOnBlur={false}
                                       error={this.state.fieldErrors["idDipartimento"]}
                                       allowAdditions
                                       additionLabel={<span className="ui left floated"><i className="ui add square icon"/>Aggiungi il nuovo dipartimento: </span>}
                                       onAddItem={this.onDropdownAddDipartimento}
                        />
                        {/*<Form.Field width={1} disabled={this.state.organizzazione == null || this.isLoadingInProgress()}>*/}
                        {/*<label>Nuovo</label>*/}
                        {/*<a onClick={() => (this.onDipartimentoStateChange('N'))} className="ui  icon  button"><i className="add icon"/></a>*/}
                        {/*</Form.Field>*/}
                        {/*<Form.Field width={1} disabled={this.state.dipartimento === null || this.state.dipartimento.idDipartimento === client.getConfigurazione().idDipartimento.idDipartimento || this.isLoadingInProgress()}>*/}
                        {/*<label>Modifica</label>*/}
                        {/*<a onClick={() => (this.onDipartimentoStateChange('E'))} className="ui  icon  button"><i className="edit icon"/></a>*/}
                        {/*</Form.Field>*/}
                    </Form.Group>
                </h3>
                <div className="ui attached segment">

                    {/* Campi del Dipartimento */}
                    <div hidden={!this.isNessunDipartimento()}>
                    <Form.Group widths="2">
                        <Form.Field label="Nome" width={10} required={false} control={Input} name='dipartimento.nome'  autoComplete="nope" placeholder='Nome dipartimento' maxLength="100"  value={this.state.fields.dipartimento.nome}  onChange={this.onInputChange}/>
                        <Form.Input label='Sito web' name='dipartimento.web' autoComplete="nope" width={6} value={this.state.fields.dipartimento.web} error={this.state.fieldErrors["web"]} onChange={this.onInputChange}/>
                    </Form.Group>
                    <Form.Group widths='5'>
                        <Form.Input label='Indirizzo' name='dipartimento.indirizzo'  disabled={this.isIndirizzoSoggetto()}  autoComplete="nope" placeholder='Via/Piazza...' width={6} maxLength={255} value={this.state.fields.dipartimento.indirizzo} onChange={this.onInputChange}/>
                        <Form.Input label='Stato' name='dipartimento.stato'  disabled={this.isIndirizzoSoggetto()} placeholder='' autoComplete="nope"  width={1} maxLength={2} value={this.state.fields.dipartimento.stato} onChange={this.onInputChangeUppercase} />
                        <Form.Input label='CAP' name='dipartimento.cap'   disabled={this.isIndirizzoSoggetto()} autoComplete="nope" placeholder='' width={2} maxLength={10} value={this.state.fields.dipartimento.cap} onChange={this.onInputChange} />
                        <Form.Input label='Città' name='dipartimento.citta'   disabled={this.isIndirizzoSoggetto()} autoComplete="nope" placeholder='' width={5} maxLength={255} value={this.state.fields.dipartimento.citta} onChange={this.onInputChangeUppercase}/>
                        <Form.Input label='Provincia' name='dipartimento.provincia'  disabled={this.isIndirizzoSoggetto()}  autoComplete="nope" placeholder='' width={2} maxLength={2} value={this.state.fields.dipartimento.provincia} onChange={this.onInputChangeUppercase}/>
                    </Form.Group>
                    <Form.Group widths='5'>
                        <Form.Input label='Email' name='dipartimento.email'  autoComplete="nope"  value={this.state.fields.dipartimento.email} error={this.state.fieldErrors["email"]} onChange={this.onInputChange}/>
                        <Form.Input label='PEC'  name='dipartimento.pec' autoComplete="nope" value={this.state.fields.dipartimento.pec} error={this.state.fieldErrors["pec"]} onChange={this.onInputChange}/>
                        <Form.Input label='Tel1'  name='dipartimento.telefono1' maxLength={30}  autoComplete="nope" value={this.state.fields.dipartimento.telefono1} error={this.state.fieldErrors["telefono1"]} onChange={this.onInputChange}/>
                        <Form.Input label='Tel2'  name='dipartimento.telefono2' maxLength={30}  autoComplete="nope" value={this.state.fields.dipartimento.telefono2} error={this.state.fieldErrors["telefono2"]} onChange={this.onInputChange}/>
                        <Form.Input label='Fax'  name='dipartimento.fax' maxLength={30}  autoComplete="nope" value={this.state.fields.dipartimento.fax} error={this.state.fieldErrors["fax"]} onChange={this.onInputChange}/>
                    </Form.Group>
                    <Form.TextArea name='dipartimento.note' label='Note'  autoComplete="nope" placeholder='' rows='3' value={this.state.fields.dipartimento.note} onChange={this.onInputChange}/>
                        {loaderDipartimento}
                    </div>

                </div>
                <h3 className="ui block attached header">Soggetto</h3>
                <div className="ui attached segment">

                    <Form.Group widths="5">
                        <Form.Dropdown label='Titolo' width={2} name='soggetto.titolo' fluid selection search options={this.state.soggettoTitoliList} value={''+this.state.fields.soggetto.titolo} onChange={this.onInputChange}/>
                        <Form.Field label="Nome" width={4} required={false} autoComplete="nope" control={Input} name='soggetto.nome' placeholder='' maxLength="255"  value={this.state.fields.soggetto.nome}  onChange={this.onInputChangeFirstCharUppercase}/>
                        <Form.Field label="Cognome" width={4} required={false} autoComplete="nope" control={Input} name='soggetto.cognome' placeholder='' maxLength="255"  value={this.state.fields.soggetto.cognome}  onChange={this.onInputChangeUppercase}/>
                        <Form.Dropdown label='Sesso' width={2} name='soggetto.sesso' fluid selection search options={optionsSoggettiSesso} value={''+this.state.fields.soggetto.sesso} onChange={this.onInputChange}/>
                        <Form.Input label='Codice Fiscale' disabled={this.state.fields.organizzazione.cfisc} width={4} name='soggetto.cfisc' placeholder='' autoComplete="nope" maxLength={16}  value={this.state.fields.soggetto.cfisc} onChange={this.onInputChangeUppercase}/>
                    </Form.Group>
                    <Form.Group widths="6">
                        <Form.Field inline >
                            <Checkbox label="Prospect" name="soggetto.isProspect" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.isProspect} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Cliente" name="soggetto.isCliente" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.isCliente} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Fornitore" name="soggetto.isFornitore" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.isFornitore} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Terze Parti" name="soggetto.isTp" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.isTp} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Consenso" name="soggetto.prvcyConsenso" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.prvcyConsenso} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Avvisato" name="soggetto.prvcyAvvisato" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.prvcyAvvisato} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths='5'>
                        <Form.Input label='Indirizzo' name='soggetto.indirizzo'  disabled={this.isIndirizzoOrganizzazione() || this.isIndirizzoDipartimento()} placeholder='Via/Piazza...' autoComplete="nope" width={6} maxLength={255} value={this.state.fields.soggetto.indirizzo} onChange={this.onInputChange}/>
                        <Form.Input label='Stato' name='soggetto.stato'  disabled={this.isIndirizzoOrganizzazione() || this.isIndirizzoDipartimento()} placeholder='' autoComplete="nope"  width={1} maxLength={2} value={this.state.fields.soggetto.stato} onChange={this.onInputChangeUppercase} />
                        <Form.Input label='CAP' name='soggetto.cap'  disabled={this.isIndirizzoOrganizzazione() || this.isIndirizzoDipartimento()} placeholder='' autoComplete="nope"  width={2} maxLength={10} value={this.state.fields.soggetto.cap} onChange={this.onInputChange} />
                        <Form.Input label='Città' name='soggetto.citta'  disabled={this.isIndirizzoOrganizzazione() || this.isIndirizzoDipartimento()} placeholder='' autoComplete="nope" width={5} maxLength={255} value={this.state.fields.soggetto.citta} onChange={this.onInputChangeUppercase}/>
                        <Form.Input label='Provincia' name='soggetto.provincia'  disabled={this.isIndirizzoOrganizzazione() || this.isIndirizzoDipartimento()} placeholder='' autoComplete="nope" width={2} maxLength={2} value={this.state.fields.soggetto.provincia} onChange={this.onInputChangeUppercase}/>
                    </Form.Group>
                    <Form.Group widths='5'>
                        <Form.Input label='Email'  name='soggetto.email' autoComplete="nope"  value={this.state.fields.soggetto.email} error={this.state.fieldErrors["email"]} onChange={this.onInputChange}/>
                        <Form.Input label='PEC'  name='soggetto.pec' autoComplete="nope"  value={this.state.fields.soggetto.pec} error={this.state.fieldErrors["pec"]} onChange={this.onInputChange}/>
                        <Form.Input label='Tel1'  name='soggetto.telefono1' maxLength={30} autoComplete="nope" value={this.state.fields.soggetto.telefono1} error={this.state.fieldErrors["telefono1"]} onChange={this.onInputChange}/>
                        <Form.Input label='Tel2'  name='soggetto.telefono2' maxLength={30} autoComplete="nope" value={this.state.fields.soggetto.telefono2} error={this.state.fieldErrors["telefono2"]} onChange={this.onInputChange}/>
                        <Form.Input label='Fax'  name='soggetto.fax' maxLength={30} autoComplete="nope" value={this.state.fields.soggetto.fax} error={this.state.fieldErrors["fax"]} onChange={this.onInputChange}/>
                        {/*<Form.Input label='Sito web' name='web' autoComplete="nope" width={8} value={this.state.fields.web} error={this.state.fieldErrors["web"]} onChange={this.onInputChange}/>*/}
                    </Form.Group>
                    <Form.Group widths='4'>
                        <Form.Input label='Cellulare' name='soggetto.cellulare' maxLength={30} autoComplete="nope" value={this.state.fields.soggetto.cellulare} error={this.state.fieldErrors["cellulare"]} onChange={this.onInputChange}/>
                        <Form.Input label='P.IVA' disabled={this.state.fields.organizzazione.piva} name='soggetto.piva'  placeholder='' autoComplete="nope" maxLength={11}  value={this.state.fields.soggetto.piva} onChange={this.onInputChangeUppercase}/>
                        <Form.Input label='Email personale' name='soggetto.perEmail'  autoComplete="nope" value={this.state.fields.soggetto.perEmail} error={this.state.fieldErrors["perEmail"]} onChange={this.onInputChange}/>
                        <Form.Input label='Cellulare personale' name='soggetto.perCellulare'  maxLength={30} autoComplete="nope" value={this.state.fields.soggetto.perCellulare} error={this.state.fieldErrors["perCellulare"]} onChange={this.onInputChange}/>
                    </Form.Group>
                    {/*<Form.Group widths='2'>*/}
                        {/*<Form.Input label='Nome Organizzazione' autoComplete="nope" name='nomeOrg' width={8} value={this.state.fields.nomeOrg} error={this.state.fieldErrors["nomeOrg"]} onChange={this.onInputChange}/>*/}
                        {/*<Form.Input label='Telefono Organizzazione' autoComplete="nope" name='telOrg' width={8} value={this.state.fields.telOrg} error={this.state.fieldErrors["telOrg"]} onChange={this.onInputChange}/>*/}
                    {/*</Form.Group>*/}
                    {/*<Form.Group widths='2'>*/}
                        {/*<Form.Input label='Cellulare Dipartimento' autoComplete="nope" name='cellDip' width={8} value={this.state.fields.cellDip} error={this.state.fieldErrors["cellDip"]} onChange={this.onInputChange}/>*/}
                        {/*<Form.Input label='Email Dipartimento' autoComplete="nope" type="email" name='emailDip' width={8} value={this.state.fields.emailDip} error={this.state.fieldErrors["emailDip"]} onChange={this.onInputChange}/>*/}
                    {/*</Form.Group>*/}
                    <Form.TextArea name='soggetto.note' label='Note' autoComplete="nope" placeholder='' rows='3' value={this.state.fields.soggetto.note} onChange={this.onInputChange}/>
                </div>
                <h3 className="ui block attached header">Privacy</h3>
                <div className="ui attached segment">
                    <Form.Group widths="1">
                        <Form.Field inline >
                            <Checkbox label="Dati Sensibili?" name="soggetto.prvcyDatiSensibili" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyDatiSensibili} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                    </Form.Group>
                    <Divider fitted />
                    <h4> Categoria di Dati </h4>
                    <Form.Group widths="4">
                        <Form.Field inline >
                            <Checkbox label="Dati personali (Comuni)" name="soggetto.prvcyCatdatPersonali" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyCatdatPersonali} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Dati identificativi" name="soggetto.prvcyCatdatIdentificativi" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyCatdatIdentificativi} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Dati sensibili" name="soggetto.prvcyCatdatSensibili" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.prvcyCatdatSensibili} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Dati giudiziari" name="soggetto.prvcyCatdatGiudiziari" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.prvcyCatdatGiudiziari} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                    </Form.Group>
                    <Divider fitted />
                    <h4> Termine Cancellazione </h4>
                    <Form.Group width="16">
                        <Form.Field inline >
                            <Radio width={8} label="Periodo necessario agli scopi per i quali sono stati raccolti" value={"0"} name="soggetto.prvcyTermineCancellazione" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyTermineCancellazione === "0"} onChange={this.onInputRadioChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Radio width={4} label="10 anni" value={"10"} name="soggetto.prvcyTermineCancellazione" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyTermineCancellazione === "10"} onChange={this.onInputRadioChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Radio width={4} label="5 anni" value={"5"} name="soggetto.prvcyTermineCancellazione" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyTermineCancellazione === "5"} onChange={this.onInputRadioChange} />
                        </Form.Field>

                    </Form.Group>
                    <Divider fitted />
                    <h4> Categoria Destinatari </h4>
                    <Form.Group widths="6">
                        <Form.Field inline >
                            <Checkbox label="Tutti coloro che saranno necessari allo svolgimento degli incarico" name="soggetto.prvcyCatdstNecessari" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyCatdstNecessari} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Collaboratori" name="soggetto.prvcyCatdstCollaboratori" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyCatdstCollaboratori} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Pubbliche Amministrazioni" name="soggetto.prvcyCatdstPubblicheAmm" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.prvcyCatdstPubblicheAmm} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Clienti" name="soggetto.prvcyCatdstClienti" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.prvcyCatdstClienti} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Fornitori" name="soggetto.prvcyCatdstFornitori" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.prvcyCatdstFornitori} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                        <Form.Field inline >
                            <Checkbox label="Sfilati" name="soggetto.sfilati" defaultIndeterminate={false}   toggle checked={this.state.fields.soggetto.sfilati} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                    </Form.Group>
                    <Divider fitted />
                    <h4>Destinatari - Paesi Terzi</h4>
                    <Form.Group widths="1">

                        <Form.Field inline >
                            <Checkbox label="Trasferimento nei Paesi Terzi" name="soggetto.prvcyDestPaesiTerzi" defaultIndeterminate={false} toggle checked={this.state.fields.soggetto.prvcyDestPaesiTerzi} onChange={this.onInputCheckboxChange} />
                        </Form.Field>
                    </Form.Group>
                    <Form.TextArea name='soggetto.prvcyMisureAdottate' label='Misure tecniche e organizzative adottate' autoComplete="nope" placeholder='' rows='4' value={this.state.fields.soggetto.prvcyMisureAdottate} onChange={this.onInputChange}/>

                </div>

                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a className="ui right floated  secondary  button" onClick={this.handleCancel}><i className="undo icon"/>Annulla</a>
                    </div>
                    {btnSalva}
                </div>

            </Form>
        )
    }

    render() {

        return (
            <div>
            {this.renderSoggettoForm()}
            </div>
        )
    }

    isNessunaOrganizzazione() {
        return !(this.state.organizzazione === null || this.state.organizzazione.idOrganizzazione === client.getConfigurazione().idDipartimento.idOrganizzazione.idOrganizzazione );
    }

    isNessunDipartimento(){
        return !(this.state.dipartimento === null || this.state.dipartimento.idDipartimento === client.getConfigurazione().idDipartimento.idDipartimento);
    }

    isIndirizzoSoggetto(){
        return this.state.fields.soggetto.indirizzo || this.state.fields.soggetto.stato ||
            this.state.fields.soggetto.cap || this.state.fields.soggetto.citta ||
            this.state.fields.soggetto.provincia;
    }

    isIndirizzoOrganizzazione(){
        return this.state.fields.organizzazione.indirizzo || this.state.fields.organizzazione.stato ||
            this.state.fields.organizzazione.cap || this.state.fields.organizzazione.citta ||
            this.state.fields.organizzazione.provincia;
    }

    isIndirizzoDipartimento(){
        return this.state.fields.dipartimento.indirizzo || this.state.fields.dipartimento.stato ||
            this.state.fields.dipartimento.cap || this.state.fields.dipartimento.citta ||
            this.state.fields.dipartimento.provincia;
    }
}
RubricaFormAll.contextTypes = {
    router: PropTypes.object,
}

export default RubricaFormAll;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaFormAll.js
 **/